import * as types from '../../action-types';
import {getAllConsumers as initialState } from "../../initialState";

const getAllConsumers = (state=initialState, action) => {
  switch (action.type) {
    case types.GET_ALL_CONSUMERS_START:
      return {
        ...state,
        isLoading: true
      };
    case types.GET_ALL_CONSUMERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isSuccessful: true,
        data: action.payload
      };
    case types.GET_ALL_CONSUMERS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload
      };
    case types.GET_ALL_CONSUMERS_CLEANUP:
      return {
        ...state,
        isLoading: false,
        isSuccessful: false,
        error: null
      };
    default:
      return state;
  }
}

export default getAllConsumers;
